import React from 'react';
import { Link } from 'gatsby';
import { IFontIconCard } from '@ecs/tng-common/interfaces';
import ROUTES from '../helpers/routes';

type BlogCategoryLinksProps = {
  links: IFontIconCard[];
};

export default class BlogCategoryLinks extends React.Component<BlogCategoryLinksProps> {
  render() {
    return (
      <>
        <h2 className="eyebrow-text mb-2">Explore more topics</h2>
        <ul className="list-unstyled mb-0 row gx-2 gy-2 body-text-xs">
          {this.props.links.map((link: IFontIconCard) => (
            <li
              key={link.link}
              className="w-auto mb-0">
              <Link
                to={ROUTES.BLOG.toUrl(link.link || '#')}
                className="label label-blue py-1 px-2 text-decoration-underline-hover">
                {link.heading}
              </Link>
            </li>
          ))}
        </ul>
      </>
    );
  }
}
